import React, { useEffect, useState } from "react";
import "../headerPortfolio/header.css";
import "./headerDetails.css";
import ButtonMode from "../ButtonMode";
export const HeaderDetails = ({ title }) => {
  return (
    <header className="flex ">
      <h5 style={{ marginTop: "20px" }} className="title">
        Details of "{title}"
      </h5>
      {/* button dark/light mode */}
      <ButtonMode />
    </header>
  );
};

// export default headerPortfolio
